"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleOperatorSchema = exports.impossibleOperatorBirthdayRangeSchema = exports.impossibleOperatorBirthdayStringSchema = exports.MAX_OPERATOR_AGE_IN_YEARS = exports.MIN_OPERATOR_AGE_IN_YEARS = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const dates_1 = require("../dates");
const Address_1 = require("./Address");
const BirthdayRange_1 = require("./BirthdayRange");
const Name_1 = require("./Name");
const DriversLicenseStatusTypes_1 = require("../enums/DriversLicenseStatusTypes");
const EducationTypes_1 = require("../enums/EducationTypes");
const GenderTypes_1 = require("../enums/GenderTypes");
const MaritalStatusTypes_1 = require("../enums/MaritalStatusTypes");
const RelationshipTypes_1 = require("../enums/RelationshipTypes");
const StateCodes_1 = require("../enums/StateCodes");
const _1 = require(".");
const operator_1 = require("../operator");
const Email_1 = require("./Email");
exports.MIN_OPERATOR_AGE_IN_YEARS = 14;
exports.MAX_OPERATOR_AGE_IN_YEARS = 109;
exports.impossibleOperatorBirthdayStringSchema = (0, dates_1.dateInYearsRangeStringSchemaFactory)(exports.MIN_OPERATOR_AGE_IN_YEARS, exports.MAX_OPERATOR_AGE_IN_YEARS, `Person can not be younger than ${exports.MIN_OPERATOR_AGE_IN_YEARS} years old or older than ${exports.MAX_OPERATOR_AGE_IN_YEARS} years old`);
exports.impossibleOperatorBirthdayRangeSchema = BirthdayRange_1.impossibleBirthdayRangeSchema
    .extend({
    start: zod_1.z.nullable(exports.impossibleOperatorBirthdayStringSchema).optional(),
    end: zod_1.z.nullable(exports.impossibleOperatorBirthdayStringSchema).optional(),
})
    .strict();
exports.impossibleOperatorSchema = zod_1.z
    .object({
    name: zod_1.z.nullable(Name_1.impossibleNameSchema),
    gender: zod_1.z.nullable(zod_1.z.nativeEnum(GenderTypes_1.GenderTypes)),
    maritalStatus: zod_1.z.nullable(zod_1.z.nativeEnum(MaritalStatusTypes_1.MaritalStatusTypes)),
    occupation: zod_1.z.nullable(constants_1.defaultOccupationString),
    education: zod_1.z.nullable(zod_1.z.nativeEnum(EducationTypes_1.EducationTypes)),
    rawEducation: constants_1.defaultOptionalString,
    relationship: zod_1.z.nullable(zod_1.z.nativeEnum(RelationshipTypes_1.RelationshipTypes)),
    rawRelationship: zod_1.z.nullable(zod_1.z.string().min(1).max(50).regex(constants_1.REGEX.defaultString)).optional(),
    birthday: zod_1.z.nullable(exports.impossibleOperatorBirthdayStringSchema),
    birthdayRange: zod_1.z.nullable(exports.impossibleOperatorBirthdayRangeSchema),
    ageLicensed: zod_1.z.nullable(zod_1.z.number().min(exports.MIN_OPERATOR_AGE_IN_YEARS).max(exports.MAX_OPERATOR_AGE_IN_YEARS)),
    ageLicensedInternationally: zod_1.z.nullable(zod_1.z.number().min(exports.MIN_OPERATOR_AGE_IN_YEARS).max(exports.MAX_OPERATOR_AGE_IN_YEARS)),
    isPrimary: zod_1.z.nullable(zod_1.z.boolean()),
    driversLicenseState: zod_1.z.nullable(zod_1.z.nativeEnum(StateCodes_1.StateCodes)),
    driversLicenseStatus: zod_1.z.nullable(zod_1.z.nativeEnum(DriversLicenseStatusTypes_1.DriverLicenseStatusTypes)),
    driversLicenseNumber: zod_1.z.nullable(zod_1.z.string().min(1).max(19).refine(operator_1.validateDriversLicenseNumber)),
    hasFullDriversLicenseNumber: zod_1.z.nullable(zod_1.z.boolean()),
    email: zod_1.z.nullable(Email_1.impossibleEmailSchema),
    experienceYears: zod_1.z.nullable(zod_1.z.number().min(0).max(95)),
    address: zod_1.z.nullable(Address_1.impossibleAddressSchema).optional(),
    addressRaw: zod_1.z.nullable(zod_1.z
        .string()
        .min(constants_1.MIN_DEFAULT_STRING_LENGTH)
        .max(128)
        .regex(constants_1.REGEX.defaultString)).optional(),
    phoneNumber: zod_1.z.nullable(zod_1.z.string().regex(constants_1.REGEX.phoneNumber)),
    financialResponsibilityCases: zod_1.z.nullable(zod_1.z.array(_1.impossibleFinancialResponsibilityCaseSchema)).optional(),
}).strict();
